import { render, staticRenderFns } from "./SearchNavItemCompany.vue?vue&type=template&id=48ac84ab&scoped=true&"
import script from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemCompany.vue?vue&type=style&index=0&id=48ac84ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac84ab",
  null
  
)

export default component.exports